module.exports = __webpack_public_path__ + "style/img/Group 1933(1).66c003c7.png";